module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1052-0846df46ae00eb31340ccf29364d04d7.png";